import { useNavigate } from 'react-router-dom';
import CardLayout from '../../../components/Layout/CardLayout';
import request from '../../../request/request';
import VisaFormContainer from '../../../components/Forms/Websites/Visa/VisaFormContainer';

const AddVisa = () => {
    const navigate = useNavigate();
    const addVisaHandler = (formValues) =>
        request.create('visa', formValues, () => {
            navigate('/dashboard/website/visa');
        });

    return (
        <CardLayout title='Add New Visa'>
            <VisaFormContainer apiHandler={addVisaHandler} />
        </CardLayout>
    );
};

export default AddVisa;
